// Onboarding Modal Styles
// Hosts the onboarding flow as an overlay so it can be opened from the Matches
// feed without navigating away from it.
import styled, { keyframes } from 'styled-components';
import { theme } from '../theme';

// Above the feed nav (999), the feed toast (10030) and the profile peek
// drawer (10021) — this is the topmost surface in the app while open.
const MODAL_Z = 10040;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const riseIn = keyframes`
  from { opacity: 0; transform: translateY(24px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${MODAL_Z};
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.md};
  animation: ${fadeIn} 0.25s ease;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0;
  }
`;

export const ModalPanel = styled.div`
  position: relative;
  width: 100%;
  max-width: 720px;
  max-height: 92vh;
  max-height: 92dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${theme.borderRadius.xl};
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
  animation: ${riseIn} 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: ${theme.breakpoints.mobile}) {
    max-width: 100%;
    max-height: 100vh;
    max-height: 100dvh;
    height: 100dvh;
    border-radius: 0;
    border: none;
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: ${theme.spacing.sm};
  right: ${theme.spacing.sm};
  z-index: 2;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--border-light);
  background: var(--bg-card);
  color: var(--text-primary);
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: #fff;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--border-light);
    border-radius: 4px;
  }
`;
